<template>
  <div class="design-glass">
    <div class="bg-layer">
      <img :src="heroImage" alt="" class="bg-layer__img" />
      <div class="bg-layer__blur" />
    </div>

    <front-page-design-nav theme="transparent" />

    <section class="hero">
      <div class="glass-card glass-card--hero">
        <img :src="logo" alt="BOX21" class="hero__logo" />
        <h1>{{ hero.line1 }}</h1>
        <p class="hero__sub">{{ hero.line2 }} {{ hero.line3 }}</p>
        <button type="button" class="glass-btn" @click="goToRegister">Start building</button>
      </div>
    </section>

    <section class="cards">
      <article v-for="pillar in pillars" :key="pillar.id" class="glass-card">
        <img :src="pillar.icon" :alt="pillar.title" class="cards__icon" />
        <h3>{{ pillar.title }}</h3>
        <div class="cards__tags">
          <span v-for="tag in pillar.tags" :key="tag">{{ tag }}</span>
        </div>
      </article>
    </section>

    <section class="showcase">
      <div v-for="item in showcase.slice(0, 2)" :key="item.id" class="glass-card showcase__item">
        <img :src="item.image" :alt="item.title" />
        <div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.text }}</p>
        </div>
      </div>
    </section>

    <front-page-design-footer theme="dark" />
  </div>
</template>

<script>
import FrontPageDesignNav from '@/components/front_page/designs/FrontPageDesignNav.vue'
import FrontPageDesignFooter from '@/components/front_page/designs/FrontPageDesignFooter.vue'
import { BRAND, HERO, PILLARS, SHOWCASE, HERO_IMAGE } from '@/components/front_page/designs/shared'

export default {
  name: 'DesignGlass',
  components: { FrontPageDesignNav, FrontPageDesignFooter },
  data() {
    return {
      logo: BRAND.logo,
      hero: HERO,
      pillars: PILLARS,
      showcase: SHOWCASE,
      heroImage: HERO_IMAGE,
    }
  },
  methods: {
    goToRegister() { this.$router.push({ path: '/login', query: { tab: 'register' } }) },
  },
}
</script>

<style scoped>
.design-glass {
  position: relative;
  min-height: 100vh;
  color: #fff;
  font-family: system-ui, sans-serif;
}

.bg-layer {
  position: fixed;
  inset: 0;
  z-index: 0;
}

.bg-layer__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bg-layer__blur {
  position: absolute;
  inset: 0;
  backdrop-filter: blur(20px) saturate(1.2);
  background: rgba(6, 50, 80, 0.55);
}

.hero,
.cards,
.showcase {
  position: relative;
  z-index: 1;
}

.hero {
  display: flex;
  justify-content: center;
  padding: 120px 24px 64px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.glass-card--hero {
  text-align: center;
  max-width: 560px;
}

.hero__logo {
  height: 48px;
  filter: brightness(0) invert(1);
  margin-bottom: 24px;
}

.glass-card--hero h1 {
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 700;
  margin: 0 0 16px;
  letter-spacing: -0.02em;
}

.hero__sub {
  font-size: 1.1rem;
  opacity: 0.9;
  line-height: 1.6;
  margin: 0 0 28px;
}

.glass-btn {
  background: rgba(255, 255, 255, 0.95);
  color: #0677b9;
  border: none;
  padding: 14px 32px;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px 48px;
}

.cards__icon {
  width: 40px;
  height: 40px;
  filter: brightness(0) invert(1);
  margin-bottom: 12px;
}

.cards h3 {
  font-size: 1.05rem;
  margin: 0 0 12px;
}

.cards__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.cards__tags span {
  font-size: 0.75rem;
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 999px;
}

.showcase {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px 80px;
  display: grid;
  gap: 24px;
}

.showcase__item {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 24px;
  align-items: center;
}

.showcase__item img {
  width: 100%;
  border-radius: 12px;
  aspect-ratio: 4/3;
  object-fit: cover;
}

.showcase__item h3 {
  margin: 0 0 8px;
}

.showcase__item p {
  margin: 0;
  opacity: 0.85;
  line-height: 1.6;
  font-size: 0.95rem;
}

@media (max-width: 600px) {
  .showcase__item {
    grid-template-columns: 1fr;
  }
}
</style>
